import axios from 'axios';

export default {
    async getGroup(id) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/groups/${id}`).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async getGroups() {
        return new Promise((resolve, reject) => {
            axios.get('/api/groups').then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async createGroup(group) {
        return new Promise((resolve, reject) => {
            axios.post('/api/groups', group).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async updateGroup(group) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/groups/${group.id}`, group).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },

    async deleteGroup(id) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/groups/${id}`).then((r) => {
                resolve(r);
            }).catch((r) => {
                reject(r);
            });
        });
    },
};
